import type { AffiliateUserRole } from "Types/types";

const MOONE_WEB_URL = "https://mo.one";

// Marketing-site landing page per invited role (ZS-1567); the affiliate code rides
// along so the mo.one site can hand it through to registration.
const MOONE_INFO_PATH_BY_ROLE: Record<AffiliateUserRole, string> = {
  Customer: "",
  Merchant: "/platby-a2a",
  Hunter: "/fransiza",
};

export const getMooneInfoUrl = (
  invitedUserRole: AffiliateUserRole,
  affiliateCode: string,
): string =>
  `${MOONE_WEB_URL}${MOONE_INFO_PATH_BY_ROLE[invitedUserRole]}?affiliateCode=${encodeURIComponent(affiliateCode)}`;
